import { values } from './enums'

const _enum = {
  Inactive: 0,
  Active: 1
}

export const personStatusTypes = {
  enumName: 'PersonStatusTypes',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/personStatusTypes.js